export default "__VITE_ASSET__Biwrz1$l__";